/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ds_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bytes, KB, MB, GiB…`)
};

const es_ds_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bytes, KB, MB, GiB…`)
};

const de_ds_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byte, KB, MB, GiB …`)
};

const nl_ds_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bytes, KB, MB, GiB…`)
};

const fr_ds_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Octets, KB, MB, GiB…`)
};

const it_ds_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B, KB, MB, GiB…`)
};

const pt_br2_ds_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bytes, KB, MB, GiB…`)
};

const pt_ds_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bytes, KB, MB, GiB…`)
};

const ja_ds_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バイト、KB、MB、GiB…`)
};

const zh_ds_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字节、KB、MB、GiB……`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ds_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ds_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ds_nav_main_desc", locale)
	if (locale === "en") return en_ds_nav_main_desc(inputs)
	if (locale === "es") return es_ds_nav_main_desc(inputs)
	if (locale === "de") return de_ds_nav_main_desc(inputs)
	if (locale === "nl") return nl_ds_nav_main_desc(inputs)
	if (locale === "fr") return fr_ds_nav_main_desc(inputs)
	if (locale === "it") return it_ds_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_ds_nav_main_desc(inputs)
	if (locale === "pt") return pt_ds_nav_main_desc(inputs)
	if (locale === "ja") return ja_ds_nav_main_desc(inputs)
	return zh_ds_nav_main_desc(inputs)
};